import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';
import __t from '../../locales';
import { TreeTable, TreeState } from 'cp-react-tree-table';
import { Switch } from '@material-ui/core';

export const PositionsSwitchTable = forwardRef((props, ref) => {
    console.log(props);
    const [treeValue, setTreeValue] = useState(TreeState.createEmpty());

    useEffect(() => {
        const treeData = props.allPositions.map(p => {
            return {
                data: {
                    id: p.id,
                    code: p.code,
                    name: p.name,
                    checked: Boolean(props.positions.find(pp => pp.id === p.id))
                }
            };
        });

        setTreeValue(TreeState.create(treeData));
    }, [props.allPositions, props.positions]);

    useImperativeHandle(ref, () => ({
        getSelectedPositions: () => {
            if (treeValue.hasData) {
                return treeValue.data.filter(p => p.data.checked).map(c => c.data);
            }
            return [];
        }
    }));

    return (
        <>
            <TreeTable
                value={treeValue}
                onChange={(newState) => setTreeValue(newState)}
                height={300}
            >
                <TreeTable.Column
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}>
                                <span>{row.data.name}</span>
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span>{__t('name')}</span>}
                />
                <TreeTable.Column
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}>
                                <span>{row.data.code}</span>
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span>{__t('code')}</span>}
                />
                <TreeTable.Column
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row-reverse",
                                alignItems: "center"
                            }}>
                                <Switch
                                    checked={row.data.checked}
                                    onChange={() => {
                                        row.updateData({ ...row.data, checked: !row.data.checked });
                                    }}
                                />
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span></span>}
                />
            </TreeTable>
        </>
    );
});

PositionsSwitchTable.propTypes = {
    allPositions: PropTypes.array,
    positions: PropTypes.array,
}